if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');
      }

      onSubmitHandler(event) {
        event.preventDefault();

        const submitButton = this.querySelector('[type="submit"]');
        const spinner = this.querySelector('.loading__spinner');

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.classList.add('loading');
        }

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        const formData = new FormData(this.form);

        const mainVariantId = formData.get('id');
        const quantity = Number(formData.get('quantity') || 1);

        const giftOrder = document.getElementById('giftOrderCheck')?.checked;
        const giftNote = document.getElementById('giftNoteCheck')?.checked;
        const giftMessage = document.getElementById('giftNoteText')?.value || '';
        const giftWrap = document.getElementById('giftWrapInterestCheck')?.checked;

        const items = [
          {
            id: Number(mainVariantId),
            quantity: quantity,
            properties: {
              'Gift order': giftOrder ? 'Yes' : 'No',
              'Handwritten gift note': giftNote ? 'Yes' : 'No',
              'Gift note message': giftNote ? giftMessage : '',
              'Interested in gift wrapping': giftWrap
                ? 'Yes - please confirm available options and fees'
                : 'No'
            }
          }
        ];

        if (giftNote) {
          items.push({
            id: 53037366444143,
            quantity: 1,
            properties: {
              'For product': document.querySelector('.product__title, h1')?.innerText?.trim() || 'Gift item',
              'Gift message': giftMessage || 'No message provided'
            }
          });
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
          .then((response) => response.json())
          .then(() => {
            window.location.href = '/cart';
          })
          .catch((error) => {
            console.error(error);
            alert('Error adding product to cart');
          })
          .finally(() => {
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.removeAttribute('disabled');
              submitButton.classList.remove('loading');
            }

            if (spinner) {
              spinner.classList.add('hidden');
            }
          });
      }

      handleErrorMessage() {
        return;
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable && text) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.disabled = true;

          if (this.submitButtonText) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.disabled = false;

          if (this.submitButtonText && window.variantStrings) {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form?.querySelector('[name="id"]');
      }
    }
  );
}